import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import Header from '../_shared/header/header';
import Footer from '../_shared/footer/footer';
import SubmissionHandler from '../_shared/submissionhandler/submissionhandler';
import EmailReportModal from './emailreportmodal.component';
import EmailLinkModal from '../_shared/emaillink/emaillinkmodal.component';
import Rating from '../_shared/rating/rating.component';
import { NextButton } from '../_shared/buttons/buttons.js';

import '../_shared/_sass/layout.scss';
import './results.scss';

@inject('appStore', 'routerStore', 'store')
@observer
export class ResultsComponent extends Component {
    constructor(props) {
        super(props);
        this.reportModal = React.createRef();
        this.emailModal = React.createRef();
    }

    onPrevious() {
        const { appStore, routerStore } = this.props,
            { history } = routerStore,
            numRooms = appStore.stairwells + 1;

        history.push({ pathname: `/livingroom/${numRooms}/ceiling`, state: { transition: 'back' } });
    }

    onStartOver(e) {
        const { history } = this.props.routerStore;
        history.push({ pathname: '/', state: { transition: 'back' } });
    }

    renderEmailReportInfoBlock() {
        const { store } = this.props,
            { page } = store,
            emailButton = {
                text: 'Email My Results',
                onClick: (e) => this.openReportModal()
            };

        return (
            <div className='ht-results-info-block'>
                { page.EmailReportInformation &&
                    <div dangerouslySetInnerHTML={{
                        __html: page.EmailReportInformation
                    }} /> }
                <NextButton
                    {...emailButton}
                    id='result-footer-email-result'
                    centered
                />
            </div>
        );
    };

    renderFirstSection(page) {
        const {
            ResultsSection1Title,
            ResultsSection1ResultContent1,
            ResultsSection1ResultContent2,
            ResultsRetrofitted2009Content,
            Result
        } = page;

        return (
            <section key='section-1' className='ht-section'>
                <div className='ht-section-left'>
                    <h2 className='ht-section-title'>{ResultsSection1Title}</h2>
                </div>
                <div className='ht-section-right'>
                    {Result && (
                        <>
                            <div className='ht-results-intro'>
                                {Result.HL && (
                                    <h3 className='ht-results-result'>
                                        You need <strong>{Result.HL}</strong> of heating capacity to heat your main living room
                                    </h3>
                                )}
                                {ResultsSection1ResultContent1 && (
                                    <div
                                        className='ht-results-result-content'
                                        dangerouslySetInnerHTML={{
                                            __html: ResultsSection1ResultContent1
                                        }}
                                    />
                                )}
                                {Result.AET && (
                                    <p className='ht-results-result'>
                                        Your heaters need to provide this heating capacity with an outdoor temperature of <strong>{Result.AET}</strong>
                                    </p>
                                )}
                                {ResultsSection1ResultContent2 && (
                                    <div
                                        className='ht-results-result-content'
                                        dangerouslySetInnerHTML={{
                                            __html: ResultsSection1ResultContent2
                                        }}
                                    />
                                )}

                                {/* retrofitted2009 is null, yes, no or dont know */}
                                {Result.retrofitted2009 === 'yes' && ResultsRetrofitted2009Content && (
                                    <div
                                        className='ht-results-result-content'
                                        dangerouslySetInnerHTML={{
                                            __html: ResultsRetrofitted2009Content
                                        }}
                                    />
                                )}
                                { this.renderEmailReportInfoBlock() }
                            </div>
                        </>
                    )}
                </div>
            </section>
        );
    }

    /**
     * render sections 2-5
     */
    renderSections(page) {
        const sections = [];
        let i,
            title,
            content;

        for (i = 2; i < 6; i += 1) {
            title = page[`ResultsSection${i}Title`];
            content = page[`ResultsSection${i}Content`];

            if (!content) {
                continue;
            }

            sections.push(
                <section key={`section-${i}`} className='ht-section'>
                    <div className='ht-section-left'>
                        {title && (
                            <h2 className='ht-section-title'>{title}</h2>
                        )}
                    </div>
                    <div className='ht-section-right'>
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                </section>
            );
        }

        return sections;
    }

    openReportModal = () => {
        this.reportModal.current.wrappedInstance.openModal();
    };

    /**
     * render the footer
     * - contains email report modal trigger
     */
    renderFooter() {
        const { appStore } = this.props,
            numRooms = appStore.stairwells + 1,
            prevActionName = `prev-results-to-ceiling-${numRooms}`,
            nextActionName = `prev-results-to-ceiling-${numRooms}`,
            emailResultActionName = 'next-results-to-email';

        return <>
            <div className='ht-footer-section'>
                { this.renderEmailReportInfoBlock() }
            </div>
            <Footer
                idPrefix='result'
                prevActionName={prevActionName}
                nextActionName={nextActionName}
                emailResultActionName={emailResultActionName}
                EmailResult={{
                    text: 'Email Result',
                    onClick: () => this.openReportModal()
                }}
                restart={{
                    text: 'Start Again?',
                    onClick: (e) => this.onStartOver(),
                    ternaryButton: true
                }}
                prev={{
                    onClick: (e) => this.onPrevious()
                }}
                email={{
                    text: 'Email my progress',
                    modal: this.emailModal
                }}
                showRestart
                emailProgressLinkSupText={window.HTContent.EmailProgressLinkSupText}
            />
        </>;
    }

    render() {
        const { appStore, store } = this.props,
            numRooms = appStore.stairwells + 1,
            prevActionName = `prev-results-to-ceiling-${numRooms}`;

        return (
            <div className='ht-page ht-results' key={store.page.ID}>
                {store.page.Title && (
                    <Helmet>
                        <title>{store.page.Title} Results</title>
                    </Helmet>
                )}
                <Header
                    titlePre='Heating assessment tool'
                    title='Results'
                    idPrefix='results'
                    prevActionName={prevActionName}
                    prev={{
                        onClick: () => this.onPrevious()
                    }}
                    email={{
                        text: 'Email a link to my result',
                        modal: this.emailModal
                    }}
                />
                <SubmissionHandler store={store} showLoading>
                    <div className='ht-layout'>
                        {this.renderFirstSection(store.page)}
                        {this.renderSections(store.page)}
                        {this.renderFooter()}
                        <Rating />
                    </div>
                </SubmissionHandler>
                <EmailReportModal ref={this.reportModal}/>
                <EmailLinkModal ref={this.emailModal} />
            </div>
        );
    }
}
